import React, { Component } from "react";
import { Collapse, Tooltip, Icon } from "antd";
import ClickToCopy from "../../../../Common/ClickToCopy";
import { ReactComponent as link } from "../../../../../../assets/images/icons/link.svg";
import moment from "moment";
import "./index.scss";

const { Panel } = Collapse;

class Expandable extends Component {
  render() {
    let order = this.props.order;
    let product_img =
      order && order.images && order.images.length > 0 && order.images[0].url;

    return (
      <>
        <Collapse className="collapse-item-logs" expandIconPosition="right">
          <Panel
            onClick={(event) => event.stopPropagation()}
            showArrow={false}
            header={
              <div
                className="container"
                style={{ cursor: "auto" }}
                onClick={(event) => event.stopPropagation()}
              >
                <div
                  className="details"
                  onClick={(event) => event.stopPropagation()}
                >
                  <div className="img">
                    <img src={order.image} alt="" />
                  </div>
                  <div className="product-link-name">
                    <p>
                      {order.name && order.name.length <= 20 ? (
                        <a
                          href={
                            `${process.env.REACT_APP_NEW_APP}` +
                            "/productDetails/" +
                            order.prod_id
                          }
                          target="_blank"
                          className="view-in-vf-link"
                          rel="noopener noreferrer"
                        >
                          {order.name}
                          <Icon
                            component={link}
                            style={{ marginLeft: "6px" }}
                          />
                        </a>
                      ) : (
                        <Tooltip title={order.name}>
                          {" "}
                          <p className="order-id-link">
                            {order.name ? (
                              <a
                                href={
                                  `${process.env.REACT_APP_NEW_APP}` +
                                  "/productDetails/" +
                                  order.prod_id
                                }
                                target="_blank"
                                className="view-in-vf-link"
                                rel="noopener noreferrer"
                              >
                                {" "}
                                {order.name.slice(0, 20) + "..."}
                                <Icon
                                  component={link}
                                  style={{ marginLeft: "6px" }}
                                />
                              </a>
                            ) : (
                              " Name not available"
                            )}
                          </p>
                        </Tooltip>
                      )}
                    </p>

                    <ClickToCopy
                      width={true}
                      inventoryId={order.sku}
                      textToCopy={order.sku}
                    />
                  </div>{" "}
                </div>
                <div className="InventoryE">
                  <span style={{ color: "#898989" }}>
                    {order.source.split(":")[0].toLowerCase() === "awb" ||
                    order.source.split(":")[0].toLowerCase() === "rto" ? (
                      <Tooltip title="Return">
                        <span>{order.source.split(":")[0] + ":"}</span>
                        <span>
                          <a
                            href={`https://track.vcfl.express/?waybill=${
                              order.source.split(":")[1]
                            }`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {order.source.split(":")[1]}
                          </a>
                        </span>
                      </Tooltip>
                    ) : (
                      <>
                        {" "}
                        <span>
                          {" "}
                          {order.source.split(":")[0] + ":" === "Manual Added:"
                            ? "Manual Added"
                            : order.source.split(":")[0] + ":"}
                        </span>{" "}
                        {order.source.split(":")[0] === "Booking Request ID" ? (
                          <a
                            href={`./requests/sourcing-requests?search=${order.source
                              .split(":")[1]
                              .trim()}`}
                          >
                            <span>{order.source.split(":")[1]}</span>
                          </a>
                        ) : (
                          <span>{order.source.split(":")[1]}</span>
                        )}
                      </>
                    )}
                  </span>
                </div>
                {order.warehouse ? (
                  <>
                    <div
                      className="location_fc"
                      style={{
                        display: "flex",

                        alignItems: "center",
                        gap: "4px",
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="14.047"
                        viewBox="0 0 24 24.047"
                        // style={{ marginTop: "4px" }}
                      >
                        <path
                          id="Path_5728"
                          data-name="Path 5728"
                          d="M24.087,5.186,12.768.064a.7.7,0,0,0-.582,0L.914,5.186A.7.7,0,0,0,.5,5.828V23.343a.7.7,0,0,0,.7.7H23.8a.7.7,0,0,0,.7-.7V5.828A.7.7,0,0,0,24.087,5.186ZM16.939,19.821a.7.7,0,0,0,.7-.7v-.7h1.409v4.227H14.826V18.412h1.409v.7A.7.7,0,0,0,16.939,19.821ZM19.053,17H14.121a.7.7,0,0,0-.7.7v4.932H11.538V12.071a.7.7,0,0,0-.7-.7H5.9V9.958H19.053ZM5.9,17V12.776H7.311v.7a.7.7,0,0,0,1.409,0v-.7h1.409V17Zm0,1.409H7.311v.7a.7.7,0,0,0,1.409,0v-.7h1.409v4.227H5.9Zm17.19,4.227h-2.63V9.253a.7.7,0,0,0-.7-.7H5.2a.7.7,0,0,0-.7.7V22.639H1.91V6.281l10.568-4.8,10.614,4.8Z"
                          transform="translate(-0.501 -0.001)"
                        />
                      </svg>
                      <span style={{ color: "#898989" }}>
                        {order.warehouse}
                      </span>
                    </div>
                  </>
                ) : (
                  "N.A"
                )}

                <div>
                  <p style={{ color: "#898989" }}>
                    {order.type + ":  "}{" "}
                    <span
                      style={{
                        color: `${
                          order.type === "Inward" ? `#229D1B` : `#C70C3C`
                        }`,
                      }}
                    >
                      {" "}
                      {order.type === "Inward" ? <span>+</span> : null}
                      {order.qty}{" "}
                    </span>
                  </p>
                  <p style={{ color: "#898989" }}>
                    {" "}
                    Dated:
                    <span> {moment(order.date).format("DD MMM, YYYY")}</span>
                  </p>
                </div>
              </div>
            }
            key="1"
          />
        </Collapse>

        {/* logs */}
      </>
    );
  }
}

export default Expandable;
